<template>
  <div
    v-if="totalPrice.ticketsSelecteds > 0 || isCrossingSell"
    :style="getPersonalizedBannerBox"
    class="bottom-0 md:flex justify-center items-center hidden mt-auto banner--ios"
    :class="ticketOffice ? 'purchase-office-banner' : 'purchase-banner'"
  >
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      class="ml-1 h-8 md:h-11 md:ml-2.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.7341 14.5524C42.554 14.2921 42.3134 14.0793 42.0331 13.9323C41.7527 13.7853 41.4409 13.7084 41.1243 13.7083H14.3598L12.0999 8.28376C11.8036 7.5694 11.3018 6.95912 10.6582 6.53029C10.0146 6.10146 9.25818 5.87339 8.48481 5.87501H3.91602V9.79168H8.48481L17.7751 32.0873C17.9239 32.444 18.175 32.7487 18.4966 32.963C18.8183 33.1774 19.1962 33.2917 19.5827 33.2917H35.2493C36.066 33.2917 36.7964 32.7845 37.0843 32.0227L42.9593 16.356C43.0703 16.0596 43.1079 15.7406 43.0686 15.4265C43.0294 15.1124 42.9146 14.8124 42.7341 14.5524ZM33.8922 29.375H20.8889L15.9931 17.625H38.2985L33.8922 29.375ZM20.5618 41.125C22.1842 41.125 23.4993 39.8098 23.4993 38.1875C23.4993 36.5652 22.1842 35.25 20.5618 35.25C18.9395 35.25 17.6243 36.5652 17.6243 38.1875C17.6243 39.8098 18.9395 41.125 20.5618 41.125ZM37.2077 38.1875C37.2077 39.8098 35.8925 41.125 34.2702 41.125C32.6478 41.125 31.3327 39.8098 31.3327 38.1875C31.3327 36.5652 32.6478 35.25 34.2702 35.25C35.8925 35.25 37.2077 36.5652 37.2077 38.1875Z"
        :fill="getPersonalizedBannerBox.color || '#FFF'"
      />
    </svg>
    <span
      class="price ml-1 mr-3 md:ml-4 md:mr-16"
      :style="isIframe ? getPersonalizedBannerBox : 'color: #FFF'"
    >
      {{ $t("wegow.purchase.totalToPay") }}
      {{ customPrice ? customPrice : totalPrice.totalWithTaxes }}
    </span>
    <wegow-button
      button-id="next-step-button"
      class="hidden md:block"
      color="white"
      type="button"
      size="xl"
      :style="getPersonalizedBannerBox"
      :text="
        !totalPrice.isFree ? $t('wegow.purchase.buy') : $t('general.finish')
      "
      @click="handlePurchase"
    />
    <!-- <wegow-button
      button-id="next-step-button"
      class="md:hidden block"
      color="white"
      type="button"
      size="base"
      :style="getPersonalizedBannerBox"
      :text="
        !totalPrice.isFree ? $t('wegow.purchase.buy') : $t('general.finish')
      "
      @click="createPurchase()"
    /> -->
  </div>
  <div
    v-if="totalPrice.ticketsSelecteds > 0"
    :style="getPersonalizedBannerBox"
    class="bottom-0 md:hidden justify-center items-center flex banner--ios"
    :class="ticketOffice ? 'purchase-office-banner' : 'purchase-banner'"
    @click="handlePurchase"
  >
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      class="ml-1 h-8 md:h-11 md:ml-2.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.7341 14.5524C42.554 14.2921 42.3134 14.0793 42.0331 13.9323C41.7527 13.7853 41.4409 13.7084 41.1243 13.7083H14.3598L12.0999 8.28376C11.8036 7.5694 11.3018 6.95912 10.6582 6.53029C10.0146 6.10146 9.25818 5.87339 8.48481 5.87501H3.91602V9.79168H8.48481L17.7751 32.0873C17.9239 32.444 18.175 32.7487 18.4966 32.963C18.8183 33.1774 19.1962 33.2917 19.5827 33.2917H35.2493C36.066 33.2917 36.7964 32.7845 37.0843 32.0227L42.9593 16.356C43.0703 16.0596 43.1079 15.7406 43.0686 15.4265C43.0294 15.1124 42.9146 14.8124 42.7341 14.5524ZM33.8922 29.375H20.8889L15.9931 17.625H38.2985L33.8922 29.375ZM20.5618 41.125C22.1842 41.125 23.4993 39.8098 23.4993 38.1875C23.4993 36.5652 22.1842 35.25 20.5618 35.25C18.9395 35.25 17.6243 36.5652 17.6243 38.1875C17.6243 39.8098 18.9395 41.125 20.5618 41.125ZM37.2077 38.1875C37.2077 39.8098 35.8925 41.125 34.2702 41.125C32.6478 41.125 31.3327 39.8098 31.3327 38.1875C31.3327 36.5652 32.6478 35.25 34.2702 35.25C35.8925 35.25 37.2077 36.5652 37.2077 38.1875Z"
        :fill="getPersonalizedBannerBox.color || '#FFF'"
      />
    </svg>
    <span
      class="price ml-1 mr-3 md:ml-4 md:mr-16"
      :style="isIframe ? getPersonalizedBannerBox : 'color: #FFF'"
    >
      {{ $t("wegow.purchase.totalToPay") }}
      {{ customPrice ? customPrice : totalPrice.totalWithTaxes }}
    </span>
    <svg
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8265 24.498L18.8297 26.5012L28.3313 16.9996L18.8297 7.49805L16.8265 9.50121L22.9083 15.583H9.32812V18.4163H22.9083L16.8265 24.498Z"
        :fill="getPersonalizedBannerBox.color || '#FFF'"
      />
    </svg>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { usePurchase } from "@/composables/usePurchase";
import { usePayment } from "@/composables/usePayment";
import { useIframeStyle } from "@/composables/useIframeStyle";
import { useEvent } from "@/composables/useEvent";
import { useRoute } from "vue-router";

import WegowButton from "@/components/general/forms/WegowButton";

const {
  totalPrice,
  createPurchase,
  createProductPurchase,
  setReferenceParams
} = usePurchase();
const { paymentMethods } = usePayment();
const { isIframe } = useEvent();
const { getPersonalizedBannerBox } = useIframeStyle();
const route = useRoute();

defineProps({
  ticketOffice: {
    type: Boolean,
    default: false
  },
  customPrice: {
    type: Number,
    default: undefined
  }
});

const isCrossingSell = computed(() => {
  return (
    route.name === "PurchaseCrossingPage" ||
    route.name === "PurchaseCrossingPageWidget"
  );
});

onMounted(() => {
  let reference = {};
  if (route.query.r) {
    reference.query = { r: route.query.r };
  }
  if (route.hash) {
    reference.hash = route.hash;
  }
  setReferenceParams(reference);
});
const handlePurchase = () => {
  if (isCrossingSell.value) {
    createProductPurchase();
  } else {
    createPurchase();
  }
};
</script>

<style scoped lang="scss">
.purchase-banner {
  background-image: url("@/assets/images/purchase-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 59px;
  @media screen and (min-width: $screen-md) {
    height: 100px;
  }
}
.purchase-office-banner {
  background-color: $inputLigthBackground;
  height: 100px;
}
.price {
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  @media screen and (max-width: $screen-md) {
    font-size: 18px;
    font-weight: 800;
  }
}
</style>
<style lang="scss">
.total-price {
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  @media screen and (max-width: $screen-md) {
    font-size: 18px;
    font-weight: 800;
  }
}
.banner--ios {
  position: -webkit-sticky;
  position: sticky;
  bottom: env(safe-area-inset-bottom, 0);
}
</style>
